// =========================================
//  BLUE SKY LIFE with JR西日本 -ANAの二地域居住-
//  jr-odekake 共通の jQuery（jQueryD）が読み込まれてから初期化する。
//  ※ Webpack でバンドルされるため ESModules 形式で記述する。
//     カルーセルが必要になったら npm 版 Swiper を import する（CDN は使わない）。
// =========================================

// 実装ブレークポイント。SCSS 側 $bpSP と必ず一致させること
const BREAKPOINT_SP = 768;

// スムーススクロールの所要時間(ms)
const SCROLL_DURATION = 300;

global._isSP = false;

const Init = function () {
  const $window = $(window);
  const $html = $("html");
  const $header = $("#header_rn");

  // ヘッダー実高を CSS 変数 --header へ反映する（固定ヘッダー分のオフセット用）
  const updateHeaderHeight = function () {
    $html[0].style.setProperty("--header", $header.outerHeight());
  };

  // 画面幅から SP 判定を更新する
  const updateIsSP = function () {
    _isSP = $window.width() < BREAKPOINT_SP;
  };

  $window.on("scroll", updateHeaderHeight);
  $window.on("resize", function () {
    updateHeaderHeight();
    updateIsSP();
  });
  updateHeaderHeight();
  updateIsSP();

  // ページトップへ戻る
  $(".js-pagetop").on("click", function () {
    $("html, body").stop().animate({ scrollTop: 0 }, SCROLL_DURATION);
  });

  // ページ内アンカー（固定ヘッダー分をオフセット）
  $(".js-anchor").on("click", function (event) {
    const $target = $($(event.currentTarget).attr("href"));
    if (!$target.length) { return true; }
    $("html, body").stop().animate(
      { scrollTop: $target.offset().top - $header.outerHeight() },
      SCROLL_DURATION
    );
    return false;
  });
};

const _initTimer = setInterval(function () {
  if (typeof jQueryD !== "undefined") {
    global.$ = global.jQuery = jQueryD;
    Init();
    clearInterval(_initTimer);
  }
}, 100);
